
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/com-veure-i-escoltar/cable",
      function () {
        return require("private-next-pages/corporatiu/atencio/com-veure-i-escoltar/cable/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/com-veure-i-escoltar/cable"])
      });
    }
  